<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="门店指标"> </pageTitle>
    <basicList ref="table" :config="basicListconfig" @search="searchEvent">
      <template v-slot:additionalFeatures>
        <div class="table">
          <el-table
            :data="verticalData"
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            style="width: 100%"
            row-key="index"
            resizable
            border
            :show-overflow-tooltip="true"
            :height="basicListconfig.height || 'calc(100vh - 350px)'"
            @sort-change="sortChange"
          >
            <el-table-column width="180" prop="name" fixed="left" label="指标名称" />
            <el-table-column
              v-for="shop in shopColumns"
              :key="shop.shop_id"
              align="center"
            >
              <template slot="header">
                <span style="font-size: 12px;">{{ shop.name }}({{ shop.username }})</span>
                <el-button
                  type="text"
                  size="mini"
                  @click="editShopMetric(shop.shop_id)"
                  style="padding: 0; font-size: 12px;"
                >
                  更新
                </el-button>
              </template>
              <el-table-column width="120" label="指标">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="scope.row[shop.shop_id + '_trade']"
                    placeholder="指标"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="120" label="占比">
                <template slot-scope="scope">
                  <div style="display: flex;">
                    <el-input
                      size="small"
                      v-model="scope.row[shop.shop_id + '_ratio']"
                      placeholder="占比"
                    ></el-input>
                    <span style="margin-top: 5px; margin-left: 5px;">%</span>
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <div class="table_footer" v-if="basicListconfig.isPage">
            <p class="table_footer_total">
              共{{ basicListconfig.total }}项数据
            </p>
            <el-pagination
              background
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :page-sizes="[10, 50, 100, 500]"
              :current-page.sync="basicListconfig.searchParameters.page"
              :page-size="basicListconfig.searchParameters.limit"
              layout="sizes,prev, pager, next"
              :total="basicListconfig.total"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </basicList>
  </div>
</template>

<script>
const defaultParameters = {
    page: 1,
    limit: 10
  };
import { gettradelist, getshoplist,tradeUp,tradeAdd} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
import { mapGetters } from "vuex";
export default {
  name: "tradeManagement",
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopId: null,
      showColumn:true,
      // 列表组件参数
      basicListconfig: {
        table: true,
        loading: false,
        //height: "calc(100vh - 350px)",
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
        ],
        data: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      storeList: [],
      summarizeData: {},
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.obtainDataSource();
    // this.searchEvent({
    //   shop_id: JSON.parse(getRoles()).shop_id,
    // });
    this.getlist();
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
    shopColumns() {
      if (!this.basicListconfig.data || this.basicListconfig.data.length === 0) {
        return [];
      }
      const shopMap = new Map();
      this.basicListconfig.data.forEach(item => {
        if (!shopMap.has(item.shop_id)) {
          shopMap.set(item.shop_id, {
            shop_id: item.shop_id,
            name: item.name,
            username: item.username
          });
        }
      });
      return Array.from(shopMap.values());
    },
    verticalData() {
      if (!this.basicListconfig.data || this.basicListconfig.data.length === 0) {
        return [];
      }
      const metricNames = [
        { key: 'turnover', name: '营业额' },
        { key: 'order', name: '订单量' },
        { key: 'sales', name: '动销数' },
        { key: 'def_money', name: '毛利' },
        { key: 'shelf_product', name: '上架商品数量' },
        { key: 'wait_replenish', name: '待补货数' },
        { key: 'out_stock', name: '断货数' },
        { key: 'stock_value', name: '货值率' },
        { key: 'turnover_rate', name: '周转率' },
        { key: 'price_update', name: '价格更新数' },
        { key: 'stock_check', name: '盘库数' },
        { key: 'ai_group', name: 'AI 群' },
        { key: 'attendance', name: '考勤率' }
      ];
      
      const shopMap = new Map();
      this.basicListconfig.data.forEach(item => {
        if (!shopMap.has(item.shop_id)) {
          shopMap.set(item.shop_id, item);
        }
      });
      
      return metricNames.map((metric, index) => {
        const row = {
          index: index,
          name: metric.name,
          metricKey: metric.key
        };
        
        shopMap.forEach((shop, shopId) => {
          row[shopId + '_trade'] = shop[metric.key + '_trade'];
          row[shopId + '_ratio'] = shop[metric.key + '_ratio'];
        });
        
        return row;
      });
    }
  },
  methods: {
    handleTradeChange(row, shopId) {
      row[shopId + '_trade'] = Number(row[shopId + '_trade']) || 0;
    },
    handleRatioChange(row, shopId) {
      row[shopId + '_ratio'] = Number(row[shopId + '_ratio']) || 0;
    },
    editShopMetric(shopId) {
      const shopData = this.basicListconfig.data.find(item => item.shop_id == shopId);
      if (!shopData) return;
      
      const verticalRow = this.verticalData;
      
      const metricKeys = ['turnover', 'order', 'sales', 'def_money', 'shelf_product', 'wait_replenish', 'out_stock', 'stock_value', 'turnover_rate', 'price_update', 'stock_check', 'ai_group', 'attendance'];
      
      metricKeys.forEach(key => {
        const row = verticalRow.find(r => r.metricKey === key);
        if (row) {
          shopData[key + '_trade'] = row[shopId + '_trade'];
          shopData[key + '_ratio'] = row[shopId + '_ratio'];
        }
      });
      
      const ratioSum = 
        Number(shopData.turnover_ratio || 0) +
        Number(shopData.order_ratio || 0) +
        Number(shopData.sales_ratio || 0) +
        Number(shopData.def_money_ratio || 0) +
        Number(shopData.shelf_product_ratio || 0) +
        Number(shopData.wait_replenish_ratio || 0) +
        Number(shopData.out_stock_ratio || 0) +
        Number(shopData.stock_value_ratio || 0) +
        Number(shopData.turnover_rate_ratio || 0) +
        Number(shopData.price_update_ratio || 0) +
        Number(shopData.stock_check_ratio || 0) +
        Number(shopData.ai_group_ratio || 0) +
        Number(shopData.attendance_ratio || 0);
      
      if (ratioSum > 100) {
        this.$message.error('该门店的所有占比总和不能超过 100%，当前总和：' + ratioSum + '%');
        return;
      }
      
      const ratioFields = [
        { name: '营业额占比', value: shopData.turnover_ratio },
        { name: '订单量占比', value: shopData.order_ratio },
        { name: '动销数占比', value: shopData.sales_ratio },
        { name: '毛利占比', value: shopData.def_money_ratio },
        { name: '上架商品数量占比', value: shopData.shelf_product_ratio },
        { name: '待补货数占比', value: shopData.wait_replenish_ratio },
        { name: '断货数占比', value: shopData.out_stock_ratio },
        { name: '货值率占比', value: shopData.stock_value_ratio },
        { name: '周转率占比', value: shopData.turnover_rate_ratio },
        { name: '价格更新数占比', value: shopData.price_update_ratio },
        { name: '盘库数占比', value: shopData.stock_check_ratio },
        { name: 'AI 群占比', value: shopData.ai_group_ratio },
        { name: '考勤率占比', value: shopData.attendance_ratio }
      ];
      
      for (let field of ratioFields) {
        if (field.value && (Number(field.value) < 0 || Number(field.value) > 100)) {
          this.$message.error(field.name + '不能超过 100% 且不能小于 0');
          return;
        }
      }
      
      if (shopData.id > 0) {
        tradeUp({
          comp_id: this.compId,
          shop_id: shopId,
          turnover_trade: shopData.turnover_trade,
          turnover_ratio: shopData.turnover_ratio,
          order_trade: shopData.order_trade,
          order_ratio: shopData.order_ratio,
          sales_trade: shopData.sales_trade,
          sales_ratio: shopData.sales_ratio,
          def_money_trade: shopData.def_money_trade,
          def_money_ratio: shopData.def_money_ratio,
          shelf_product_trade: Number(shopData.shelf_product_trade) || 0,
          shelf_product_ratio: shopData.shelf_product_ratio,
          wait_replenish_trade: Number(shopData.wait_replenish_trade) || 0,
          wait_replenish_ratio: shopData.wait_replenish_ratio,
          out_stock_trade: Number(shopData.out_stock_trade) || 0,
          out_stock_ratio: shopData.out_stock_ratio,
          stock_value_trade: Number(shopData.stock_value_trade) || 0,
          stock_value_ratio: shopData.stock_value_ratio,
          turnover_rate_trade: Number(shopData.turnover_rate_trade) || 0,
          turnover_rate_ratio: shopData.turnover_rate_ratio,
          price_update_trade: Number(shopData.price_update_trade) || 0,
          price_update_ratio: shopData.price_update_ratio,
          stock_check_trade: Number(shopData.stock_check_trade) || 0,
          stock_check_ratio: shopData.stock_check_ratio,
          ai_group_trade: Number(shopData.ai_group_trade) || 0,
          ai_group_ratio: shopData.ai_group_ratio,
          attendance_trade: Number(shopData.attendance_trade) || 0,
          attendance_ratio: shopData.attendance_ratio,
          id: shopData.id
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        tradeAdd({
          comp_id: this.compId,
          shop_id: shopId,
          turnover_trade: shopData.turnover_trade,
          turnover_ratio: shopData.turnover_ratio,
          order_trade: shopData.order_trade,
          order_ratio: shopData.order_ratio,
          sales_trade: shopData.sales_trade,
          sales_ratio: shopData.sales_ratio,
          def_money_trade: shopData.def_money_trade,
          def_money_ratio: shopData.def_money_ratio,
          shelf_product_trade: Number(shopData.shelf_product_trade) || 0,
          shelf_product_ratio: shopData.shelf_product_ratio,
          wait_replenish_trade: Number(shopData.wait_replenish_trade) || 0,
          wait_replenish_ratio: shopData.wait_replenish_ratio,
          out_stock_trade: Number(shopData.out_stock_trade) || 0,
          out_stock_ratio: shopData.out_stock_ratio,
          stock_value_trade: Number(shopData.stock_value_trade) || 0,
          stock_value_ratio: shopData.stock_value_ratio,
          turnover_rate_trade: Number(shopData.turnover_rate_trade) || 0,
          turnover_rate_ratio: shopData.turnover_rate_ratio,
          price_update_trade: Number(shopData.price_update_trade) || 0,
          price_update_ratio: shopData.price_update_ratio,
          stock_check_trade: Number(shopData.stock_check_trade) || 0,
          stock_check_ratio: shopData.stock_check_ratio,
          ai_group_trade: Number(shopData.ai_group_trade) || 0,
          ai_group_ratio: shopData.ai_group_ratio,
          attendance_trade: Number(shopData.attendance_trade) || 0,
          attendance_ratio: shopData.attendance_ratio
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    editMetric(row) {
      this.shopColumns.forEach(shop => {
        const shopData = this.basicListconfig.data.find(item => item.shop_id === shop.shop_id);
        if (shopData) {
          const ratioSum = 
            Number(shopData.turnover_ratio || 0) +
            Number(shopData.order_ratio || 0) +
            Number(shopData.sales_ratio || 0) +
            Number(shopData.def_money_ratio || 0) +
            Number(shopData.shelf_product_ratio || 0) +
            Number(shopData.wait_replenish_ratio || 0) +
            Number(shopData.out_stock_ratio || 0) +
            Number(shopData.stock_value_ratio || 0) +
            Number(shopData.turnover_rate_ratio || 0) +
            Number(shopData.price_update_ratio || 0) +
            Number(shopData.stock_check_ratio || 0) +
            Number(shopData.ai_group_ratio || 0) +
            Number(shopData.attendance_ratio || 0);
          
          if (ratioSum > 100) {
            this.$message.error(shop.name + '的所有占比总和不能超过 100%，当前总和：' + ratioSum + '%');
            return;
          }
          
          const ratioFields = [
            { name: '营业额占比', value: shopData.turnover_ratio },
            { name: '订单量占比', value: shopData.order_ratio },
            { name: '动销数占比', value: shopData.sales_ratio },
            { name: '毛利占比', value: shopData.def_money_ratio },
            { name: '上架商品数量占比', value: shopData.shelf_product_ratio },
            { name: '待补货数占比', value: shopData.wait_replenish_ratio },
            { name: '断货数占比', value: shopData.out_stock_ratio },
            { name: '货值率占比', value: shopData.stock_value_ratio },
            { name: '周转率占比', value: shopData.turnover_rate_ratio },
            { name: '价格更新数占比', value: shopData.price_update_ratio },
            { name: '盘库数占比', value: shopData.stock_check_ratio },
            { name: 'AI 群占比', value: shopData.ai_group_ratio },
            { name: '考勤率占比', value: shopData.attendance_ratio }
          ];
          
          for (let field of ratioFields) {
            if (field.value && (Number(field.value) < 0 || Number(field.value) > 100)) {
              this.$message.error(shop.name + '的' + field.name + '不能超过 100% 且不能小于 0');
              return;
            }
          }
          
          if (shopData.id > 0) {
            tradeUp({
              comp_id: this.compId,
              shop_id: shop.shop_id,
              turnover_trade: shopData.turnover_trade,
              turnover_ratio: shopData.turnover_ratio,
              order_trade: shopData.order_trade,
              order_ratio: shopData.order_ratio,
              sales_trade: shopData.sales_trade,
              sales_ratio: shopData.sales_ratio,
              def_money_trade: shopData.def_money_trade,
              def_money_ratio: shopData.def_money_ratio,
              shelf_product_trade: Number(shopData.shelf_product_trade) || 0,
              shelf_product_ratio: shopData.shelf_product_ratio,
              wait_replenish_trade: Number(shopData.wait_replenish_trade) || 0,
              wait_replenish_ratio: shopData.wait_replenish_ratio,
              out_stock_trade: Number(shopData.out_stock_trade) || 0,
              out_stock_ratio: shopData.out_stock_ratio,
              stock_value_trade: Number(shopData.stock_value_trade) || 0,
              stock_value_ratio: shopData.stock_value_ratio,
              turnover_rate_trade: Number(shopData.turnover_rate_trade) || 0,
              turnover_rate_ratio: shopData.turnover_rate_ratio,
              price_update_trade: Number(shopData.price_update_trade) || 0,
              price_update_ratio: shopData.price_update_ratio,
              stock_check_trade: Number(shopData.stock_check_trade) || 0,
              stock_check_ratio: shopData.stock_check_ratio,
              ai_group_trade: Number(shopData.ai_group_trade) || 0,
              ai_group_ratio: shopData.ai_group_ratio,
              attendance_trade: Number(shopData.attendance_trade) || 0,
              attendance_ratio: shopData.attendance_ratio,
              id: shopData.id
            }).then((res) => {
              if (res.code == 1) {
                this.$message.success(shop.name + "操作成功");
                this.getlist();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          } else {
            tradeAdd({
              comp_id: this.compId,
              shop_id: shop.shop_id,
              turnover_trade: shopData.turnover_trade,
              turnover_ratio: shopData.turnover_ratio,
              order_trade: shopData.order_trade,
              order_ratio: shopData.order_ratio,
              sales_trade: shopData.sales_trade,
              sales_ratio: shopData.sales_ratio,
              def_money_trade: shopData.def_money_trade,
              def_money_ratio: shopData.def_money_ratio,
              shelf_product_trade: Number(shopData.shelf_product_trade) || 0,
              shelf_product_ratio: shopData.shelf_product_ratio,
              wait_replenish_trade: Number(shopData.wait_replenish_trade) || 0,
              wait_replenish_ratio: shopData.wait_replenish_ratio,
              out_stock_trade: Number(shopData.out_stock_trade) || 0,
              out_stock_ratio: shopData.out_stock_ratio,
              stock_value_trade: Number(shopData.stock_value_trade) || 0,
              stock_value_ratio: shopData.stock_value_ratio,
              turnover_rate_trade: Number(shopData.turnover_rate_trade) || 0,
              turnover_rate_ratio: shopData.turnover_rate_ratio,
              price_update_trade: Number(shopData.price_update_trade) || 0,
              price_update_ratio: shopData.price_update_ratio,
              stock_check_trade: Number(shopData.stock_check_trade) || 0,
              stock_check_ratio: shopData.stock_check_ratio,
              ai_group_trade: Number(shopData.ai_group_trade) || 0,
              ai_group_ratio: shopData.ai_group_ratio,
              attendance_trade: Number(shopData.attendance_trade) || 0,
              attendance_ratio: shopData.attendance_ratio
            }).then((res) => {
              if (res.code == 1) {
                this.$message.success(shop.name + "操作成功");
                this.getlist();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }
        }
      });
    },

   sortChange(data) {
     this.basicListconfig.searchParameters.page = 1;
     this.basicListconfig.searchParameters.order_column = data.prop;
     this.basicListconfig.searchParameters.order_up =data.order;
    // data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
     this.getlist();
   },
    // 搜索方法
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
          if (key == "time") {
            this.basicListconfig.searchParameters["begin_time"] = data[key]
              ? data[key][0]
              : null;
            this.basicListconfig.searchParameters["end_time"] = data[key]
              ? data[key][1]
              : null;
          }
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    handleCurrentChange(val) {
      this.searchEvent(this.searchForm, val, "");
    },
    handleSizeChange(val) {
      this.searchEvent(this.searchForm, "", val);
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters["shop_id"];
        }
        return item;
      });
      this.basicListconfig.loading = true;
      gettradelist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.total = Number(res.count);
          this.basicListconfig.data = res.data;
          //this.showColumn=this.basicListconfig.data[0].shop_id==0?false:true;
          console.log(res.count);
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
        obtainDataSource() {
          getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
            (res) => {
              if (res.code == 1) {
                this.basicListconfig.search.map((item) => {
                  if (item.key == "shop_id") {
                    item.options = res.data.map((item) => {
                      return {
                        label: item.name,
                        value: item.id,
                      };
                    });
                  }
                  return item;
                });
              } else {
                this.$message.error(res.msg);
              }
            }
          );
        },
      },
    };
</script>

<style  scoped>
.search_total {
  display: flex;
  line-height: 32px;
}
.search_total p {
  font-size: 16px;
  padding: 0 10px;
  font-weight: bold;
  color: #ffa100;
}
.search_total p span {
  color: rgba(0, 0, 0, 0.6);
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/tradeManagement/index.vue